module.exports = "<ng-container *ngIf=\"!isLoading; else elseblock\">\r\n\r\n    <div class=\"empty-container\">\r\n    </div>\r\n</ng-container>\r\n<ng-template #elseblock>\r\n    <div class=\"loading-overview\">\r\n        <div class=\"loading-overview-spinner fa fa-spinner fa-pulse fa-3x fa-fw\"></div>\r\n    </div>\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/empty/empty.component.html
// module id = ../../../../../src/app/components/utils/dynamic/components/empty/empty.component.html
// module chunks = main